import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import EscrowTxnListPageUI from './EscrowTxnListPageUI.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'

class EscrowTxnListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      transactionList: null,
      filteredTransactionList: null,
      searchFilter: '',
      copyToClipboardText: null,
      downloadRequested: false,
      //
      details: false,
      account: null
    }
  }

  render() {
    return (
      <EscrowTxnListPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        accountNumber={this.props.match.params.accountNumber}
        // txn
        transactionList={this.state.transactionList}
        filteredTransactionList={this.state.filteredTransactionList}
        onDownloadEsccTxnsClick={this.onDownloadEsccTxnsClick}
        downloadRequested={this.state.downloadRequested}
        onRefreshClick={this.onRefreshClick}
        // search, copy
        searchFilter={this.state.searchFilter}
        onSearchFilterChange={this.onSearchFilterChange}
        copyToClipboardText={this.state.copyToClipboardText}
        onCopyToClipboard={this.onCopyToClipboard}
        //
        details={this.state.details}
        onDetailsClick={() => { this.setState({ details: !this.state.details }) }}
        account={this.state.account}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getEscrowTransactions(context, this.props.match.params.accountNumber, '', '')
    this.getAccounts(context)
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({ account: response.account })
  }

  getEscrowTransactions(context, accountNumber) {
    let cacheManager = new CacheManager({
      resource: `/api/su/escrowAccounts/${accountNumber}/transactions`,
      cacheKey: CacheKeys.EscrowTxns(accountNumber),
      callback: this.getEscrowTransactionsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context, {}, { year: 2024, month: 7 })
  }

  getEscrowTransactionsCallback = (response) => {

    let filtersStr = sessionStorage.getItem(CacheKeys.EscrowTxnsFilter())
    let filters = filtersStr ? JSON.parse(filtersStr) : {}

    this.applyFilters(response.transactionList, filters.searchFilter ? filters.searchFilter : '', response.errorList)
  }

  onDownloadEsccTxnsClick = (event) => {
    this.setState({ downloadRequested: true })
    RestApiUtils.get(this.props.context,
      `/api/su/accounts/${this.props.match.params.accountId}/escrowAccounts/${this.props.match.params.accountNumber}/statements/excel/fileDownloadSignedUrl`,
      this.onDownloadEsccTxnsClickCallback, null, null
    )
  }

  onDownloadEsccTxnsClickCallback = (response) => {
    this.setState({
      fileErrorList: response.errorList,
      downloadRequested: false
    })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }

  onCopyToClipboard = (text, result) => {
    this.setState({ copyToClipboardText: text })
    setTimeout(() => {
      this.setState({ copyToClipboardText: null })
    }, 3000)
  }

  onSearchFilterChange = (event) => {
    let searchFilter = event.target.value
    this.setState({ searchFilter: searchFilter })
    this.applyFilters(this.state.transactionList, searchFilter)
  }

  applyFilters(transactionList, searchFilter, errorList) {
    let filteredList = transactionList
    if (searchFilter) {
      searchFilter = searchFilter.toLocaleLowerCase()
      filteredList = filteredList.filter(txn =>
        txn.type && txn.type.includes(searchFilter) ||
        txn.climeTxnType && txn.climeTxnType.includes(searchFilter) ||
        txn.particulars.toLocaleLowerCase().includes(searchFilter) ||
        txn.accountName && txn.accountName.toLocaleLowerCase().includes(searchFilter)
      )
    }

    this.setState({
      transactionList: transactionList,
      filteredTransactionList: filteredList,
      searchFilter: searchFilter,
      errorList: errorList
    })

    let filters = { searchFilter: searchFilter }
    sessionStorage.setItem(CacheKeys.EscrowTxnsFilter(), JSON.stringify(filters))
  }

  onRefreshClick = (noBusy) => {
    CacheManager.removeObject(CacheKeys.EscrowTxns(this.props.match.params.accountNumber))
    if (noBusy === 'noBusy') {
      this.getEscrowTransactions(this.props.context, this.props.match.params.accountNumber)
    }
    else {
      this.setState({ transactionList: null, errorList: null })
      this.getEscrowTransactions(this.props.context, this.props.match.params.accountNumber)
    }
  }
}

export default withRouter(EscrowTxnListPageSF)
